import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { PRODUCTS_STATUS_QUERY_KEY } from '@/apiHooks/queryKeys';
import { addAdacEntitlement } from '../api/entitlements/addAdacEntitlement';
import { getEntitlements } from '../api/entitlements/getEntitlements';
import type { Entitlement } from '../@types/entitlement';

type EntitlementsQueryState = {
  initializing: boolean;
  isError?: boolean;
  entitlements?: Entitlement[];
};

export const useGetEntitlements = (): EntitlementsQueryState => {
  const { isLoading, data, isError } = useQuery({
    queryKey: ['entitlements'],
    queryFn: getEntitlements,
  });

  return {
    initializing: isLoading || isError,
    isError,
    entitlements: data,
  };
};

export const useAddAdacEntitlement = () => {
  const queryClient = useQueryClient();
  const { mutate, isLoading, isError } = useMutation(addAdacEntitlement, {
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries(['entitlements']),
        queryClient.invalidateQueries(['entitlements-v2']),
        queryClient.invalidateQueries(PRODUCTS_STATUS_QUERY_KEY),
      ]),
  });

  return { addEntitlement: mutate, isAddingEntitlement: isLoading, addEntitlementFailed: isError };
};
